module.exports = __webpack_public_path__ + "static/img/employee-01.64dd460.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/employee-01.png
// module id = ASp9
// module chunks = 2